import { render, staticRenderFns } from "./SirketForm.vue?vue&type=template&id=24d7db96&scoped=true&"
import script from "./SirketForm.vue?vue&type=script&lang=js&"
export * from "./SirketForm.vue?vue&type=script&lang=js&"
import style0 from "./SirketForm.vue?vue&type=style&index=0&id=24d7db96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d7db96",
  null
  
)

export default component.exports